export const menuItems = [
  {
    id: 1,
    label: "menuitems.menu.text",
    isTitle: true,
  },
  {
    id: 2,
    name: "dashboard",
    label: "menuitems.dashboards.text",
    icon: "bx bx-home-circle",
    link: "/",
    subItems: [],
  },
  {
    id: 99,
    label: "menuitems.incidentsTitle",
    isTitle: true,
  },
  {
    id: 3,
    name: "incident_statistics",
    label: "menuitems.incident.list.dashboard.text",
    link: "/incident/incident-management",
    icon: "bx bx-pie-chart-alt",
  },
  {
    id: 7,
    name: "atcc_monitor",
    label: "menuitems.incident.list.atcc.text",
    link: "/incident/atcc-monitor",
    icon: "bx bx-bar-chart-alt-2",
  },
  {
    id: 14,
    name: "atcc_events",
    label: "menuitems.incident.list.atccEvents.text",
    link: "/incident/atcc-events",
    icon: "bx bx-bus",
  },
  {
    id: 4,
    name: "accidents_statistics",
    label: "menuitems.incident.list.accident.text",
    link: "/incident/accidents",
    icon: "bx bx-car",
  },
  {
    id: 13,
    name: "track_incidents",
    label: "menuitems.incident.list.incidents.text",
    link: "/incident/all-incidents",
    icon: "bx bx-pin",
  },
  {
    id: 5,
    name: "vids_incidents",
    label: "menuitems.incident.list.vids",
    link: "/incident/vids-incidents",
    icon: "bx bx-camera",
  },
  {
    id: 6,
    name: "vsds_incidents",
    label: "menuitems.incident.list.vsds.text",
    link: "/incident/vsds-incidents",
    icon: "bx bx-wind",
  },
  {
    id: 8,
    name: "challans",
    label: "menuitems.incident.list.challans.text",
    link: "/incident/echallan",
    icon: "bx bx-receipt",
  },
  {
    id: 9,
    name: "reports",
    label: "menuitems.incident.list.reports.text",
    link: "/incident/reports",
    icon: "bx bx-file",
  },
  {
    id: 11,
    name: "settings",
    label: "menuitems.administration.list.account.text",
    icon: "bx bx-wrench",
    link: "/administration/account-settings",
  },
  {
    id: 12,
    name: "administration",
    label: "menuitems.administration.text",
    icon: "bx bx-shield",
    subItems: [
      {
        id: 41,
        name: "location_settings",
        label: "menuitems.administration.list.location.text",
        link: "/administration/location-settings",
        parentId: 12,
      },
      {
        id: 53,
        name: "nms_management",
        label: "menuitems.administration.list.nms.text",
        link: "/administration/nms-management",
        parentId: 12,
      },
      {
        id: 42,
        name: "device_management",
        label: "menuitems.administration.list.device.text",
        link: "/administration/device-management",
        parentId: 12,
      },
      {
        id: 43,
        name: "company_management",
        label: "menuitems.administration.list.company.text",
        link: "/administration/company-management",
        parentId: 12,
      },
      {
        id: 44,
        name: "package_management",
        label: "menuitems.administration.list.package.text",
        link: "/administration/package-management",
        parentId: 12,
      },
      {
        id: 45,
        name: "rpo_management",
        label: "menuitems.administration.list.rpo.text",
        link: "/administration/rpo-management",
        parentId: 12,
      },
      {
        id: 46,
        name: "user_management",
        label: "menuitems.administration.list.user.text",
        link: "/administration/user-management",
        parentId: 12,
      },
      {
        id: 47,
        name: "emergency_management",
        label: "menuitems.administration.list.emergency.text",
        link: "/administration/emergency-management",
        parentId: 12,
      },
      {
        id: 52,
        name: "speed_rules",
        label: "menuitems.administration.list.speed.text",
        link: "/administration/speed-limit-rules",
        parentId: 12,
      },
      {
        id: 49,
        name: "mqtt_management",
        label: "menuitems.administration.list.mqtt.text",
        link: "/administration/mqtt-management",
        parentId: 12,
      },
      {
        id: 52,
        name: "api_management",
        label: "menuitems.administration.list.api.text",
        link: "/administration/api-management",
        parentId: 12,
      },
      {
        id: 50,
        name: "vms_device_management",
        label: "menuitems.administration.list.vmsDevice.text",
        link: "/administration/vms-device-management",
        parentId: 12,
      },
      {
        id: 51,
        name: "vms_template_management",
        label: "menuitems.administration.list.vmsGroup.text",
        link: "/administration/vms-template-management",
        parentId: 12,
      },
    ],
  },
];
